// Mock data for Salomon Murciano website

export const heroImage = 'https://images.unsplash.com/photo-1431576901776-e539bd916ba2?w=1400&q=85';
export const aboutImage = 'https://images.unsplash.com/photo-1710956394109-aaa3710e3a63?w=1200&q=85';
export const aboutPageImage = 'https://images.unsplash.com/photo-1678182451047-196f22a4143e?w=1400&q=85';
export const warehouseHeroImage = 'https://images.unsplash.com/photo-1785332976732-df01aa7b2fc2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHw0fHxkaXN0cmlidXRpb24lMjBjZW50ZXJ8ZW58MHx8fHwxNzkwNjAyNTExfDA&ixlib=rb-4.1.0&q=85';
export const warehouseImage = 'https://customer-assets-cm19k8pv.emergentagent.net/job_murciano-invest/artifacts/8bo73f9k_image.png';
export const warehouse2Image = 'https://images.unsplash.com/photo-1638135724311-ffe2560001dc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwyfHxhcHBhcmVsJTIwd2FyZWhvdXNlfGVufDB8fHx8MTc5MDYwMTY5N3ww&ixlib=rb-4.1.0&q=85';
export const nycImage = 'https://images.unsplash.com/photo-1541336032412-2048a678540d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwyfHxuZXclMjB5b3JrJTIwc2t5bGluZXxlbnwwfHx8fDE3OTA2MDE2OTd8MA&ixlib=rb-4.1.0&q=85';
export const nyc2Image = 'https://images.unsplash.com/photo-1485871981521-5b1fd3805eee?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwzfHxuZXclMjB5b3JrJTIwc2t5bGluZXxlbnwwfHx8fDE3OTA2MDE2OTd8MA&ixlib=rb-4.1.0&q=85';

export const capabilities = [
  { number: '01', title: 'Sourcing', desc: 'A global network of manufacturers and suppliers built over two decades of trusted relationships across Asia, the Americas, and Europe.' },
  { number: '02', title: 'Purchasing', desc: 'Disciplined negotiation and contracting focused on quality, timing, and margin, allowing us to secure large volumes at competitive value.' },
  { number: '03', title: 'Logistics', desc: 'Coordinated transportation, warehousing, and inventory management ensuring reliable movement of merchandise across borders.' },
  { number: '04', title: 'Distribution', desc: 'Delivery to major off-price and wholesale channels in North America, with the flexibility to respond to shifting retail demand.' },
  { number: '05', title: 'Financial Management', desc: 'Prudent working-capital deployment and counterparty management supported by institutional access to capital markets.' },
];

export const clientPartners = [
  { name: 'T.J. Maxx', tag: 'Off-Price Retail' },
  { name: 'Marshalls', tag: 'Off-Price Retail' },
  { name: 'HomeGoods', tag: 'Home Fashions' },
  { name: 'Sierra', tag: 'Outdoor Lifestyle' },
  { name: 'Winners', tag: 'Canada' },
  { name: 'Burlington Stores', tag: 'Off-Price Retail' },
  { name: 'Ross Stores', tag: 'Off-Price Retail' },
  { name: 'Costco Wholesale', tag: 'Wholesale Club' },
];

export const clients = [
  { name: 'T.J. Maxx', category: 'Off-Price Retail' },
  { name: 'Marshalls', category: 'Off-Price Retail' },
  { name: 'Burlington Stores', category: 'Off-Price Retail' },
  { name: 'Ross Stores', category: 'Off-Price Retail' },
  { name: 'Costco Wholesale', category: 'Wholesale Club' },
  { name: 'TJX Companies', category: 'Off-Price Retail' },
];

export const brandCategories = [
  { title: 'Sports & Performance', items: ['Athletic Apparel', 'Performance Footwear', 'Outdoor Gear', 'Training Accessories'] },
  { title: 'Denim & Lifestyle', items: ['Premium Denim', 'Casualwear', 'Everyday Lifestyle'] },
  { title: 'Fashion & Apparel', items: ['Contemporary Fashion', 'Ready-to-Wear', 'Accessories', 'Seasonal Collections'] },
];

export const companies = [
  { name: 'Apparel Distribution', role: 'Core Division', desc: 'Global sourcing and off-price distribution platform serving major North American retailers with branded merchandise at scale.' },
  { name: 'Denim & Lifestyle', role: 'Specialty Division', desc: 'Denim and casualwear programs specializing in branded closeout merchandise and controlled brand development.' },
  { name: 'Real Estate Holdings', role: 'Investment Division', desc: 'Long-horizon real estate investment across commercial and value-add opportunities in metropolitan markets.' },
];

export const stats = [
  { value: '20+', label: 'Years of Experience' },
  { value: '$700M', label: 'Approx. Group Value' },
  { value: 'Global', label: 'Business Network' },
  { value: 'NYC', label: 'Headquartered' },
];

export const blogPosts = [
  {
    id: 1,
    date: 'September 22, 2026',
    title: 'Why Small Gifts Create Big Change in Communities Everywhere',
    excerpt: 'A closer look at how modest, consistent giving builds lasting impact across local and international communities.',
    image: 'https://images.unsplash.com/photo-1710093072228-8c3129f27357?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwxfHxjaGFyaXR5JTIwY29tbXVuaXR5fGVufDB8fHx8MTc5MDYwMTczMnww&ixlib=rb-4.1.0&q=85',
    category: 'Philanthropy',
  },
  {
    id: 2,
    date: 'September 12, 2026',
    title: 'Make a Difference Far From Home: A Guide to Volunteering Abroad',
    excerpt: 'Practical steps for professionals who want to contribute their time and skills to meaningful causes abroad.',
    image: 'https://images.unsplash.com/photo-1632932693914-89b90ae3d16d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwxfHx2b2x1bnRlZXJpbmclMjBhYnJvYWR8ZW58MHx8fHwxNzkwNjAxNzMyfDA&ixlib=rb-4.1.0&q=85',
    category: 'Community',
  },
  {
    id: 3,
    date: 'August 28, 2026',
    title: 'Global Trade and Retail Expansion: Why International Commerce Keeps Markets Growing',
    excerpt: 'Insights from two decades in cross-border trade on how modern supply chains fuel resilient retail growth.',
    image: 'https://images.unsplash.com/photo-1724597500306-a4cbb7d1324e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwyfHxnbG9iYWwlMjB0cmFkZXxlbnwwfHx8fDE3OTA2MDE3MzJ8MA&ixlib=rb-4.1.0&q=85',
    category: 'Trade',
  },
  {
    id: 4,
    date: 'August 25, 2026',
    title: 'Luxury or Budget Travel: Finding the Journey That Fits You',
    excerpt: 'A thoughtful comparison of travel styles for people who value experience as much as the destination.',
    image: 'https://images.unsplash.com/photo-1661954864180-e61dea14208a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjB0cmF2ZWx8ZW58MHx8fHwxNzkwNjAxNzMyfDA&ixlib=rb-4.1.0&q=85',
    category: 'Lifestyle',
  },
];

export const timeline = [
  { year: 'Caracas', title: 'Early Beginnings', desc: 'Born in Venezuela, Salomon developed an entrepreneurial mindset early, exploring international trade and outsourcing from China.' },
  { year: '2000s', title: 'Building the Platform', desc: 'Established sourcing relationships and gained deep expertise in apparel supply chains across global markets.' },
  { year: '2010s', title: 'Off-Price Leadership', desc: 'Recognized inefficiencies in excess-inventory markets and built a scalable distribution model for branded closeout merchandise.' },
  { year: '2023', title: 'Strategic Partnership', desc: 'Executed a significant joint venture demonstrating the Group\u2019s financial strength and access to institutional capital.' },
  { year: 'Today', title: 'Retail & Investment', desc: 'Leading a portfolio of companies across apparel distribution and real estate investment based in New York City.' },
];
